import React, { Component } from 'react'
import _ from 'lodash'
import moment from 'moment'
import {
  PlusOutlined,
  SearchOutlined,
  LockOutlined,
  ExclamationCircleOutlined
} from '@ant-design/icons'
import { Button, message, Tabs, Input, Modal, Checkbox } from 'antd'
import Highlighter from 'react-highlight-words'
import RightDrawer from '../../components/UI/rightDrawer'
import DataTable from '../../components/UI/table'
import PolygonAvatar from '../../components/UI/polygonAvatar'
import { getClients, editClient } from '../../api/team'
import { getClientList } from '../../models/breadcrumb.model'
import ClientForm from '../../components/modalFrom/clientForm'
import WelcomeEmail from '../../components/modalFrom/welcomeEmail'
import { deletePeople } from '../../api/people'
import { getRole } from '../../utils/common'
import { ChartIcon } from '../../components/icons'
import ExportClientsDataModal from '../../components/UI/exportClientsDataModal'
import Message from '../../components/message'
import { CharacterLevel, expertServices, roleLevel, userType } from '../../utils/constant'
import { clientStyle, deleteClientStyle } from './index.sass'
import HealthkitLogo from '../../asserts/icon/goals/hk-large.png'
import GarminLogo from '../../asserts/icon/goals/garmin-large.png'
import OuraLogo from '../../asserts/icon/goals/oura-large.png'
import PolarLogo from '../../asserts/icon/goals/polar-large.png'
import WithingsLogo from '../../asserts/icon/goals/withings-large.png'

import ClientActionEditIcon from '../../asserts/icon/client/icon-client-edit.svg'
import ClientMessageIcon from '../../asserts/icon/client/icon-client-message.svg'
import ClientUnreadMessageIcon from '../../asserts/icon/client/icon-client-unread-message.svg'
import ActionNoteIcon from '../../asserts/icon/client/icon-client-note.svg'
import { loadUser } from '../../utils/storage'
import Notes from '../../components/notes'
import { deleteFacility, getFacilties } from '../../api'
import { FacilityRadioGroup } from './comps/facilityRadioGroup'
import ExpertFormModal from '../../components/modalFrom/expertFormModal'
import FacilityFormModal from '../../components/modalFrom/facilityFormModal'
import ActionAuth from '../../components/ActionAuth'
import { AuthOp, PagePermissions, PermFilter } from '../../utils/authManagement'
import CreatedClientModal from './comps/createdClientModal'

const confirm = Modal.confirm

class ClientList extends Component {
  static propTypes = {}

  state = {
    assessment: [],
    coreClient: [],
    nonCoreClient: [],
    partner: [],
    testClient: [],
    admin: [],
    archive: [],
    prospect: [],
    experts: [],
    facilities: [],
    loading: false,
    editWelcomeEmail: null,
    showMembership: false,
    editIndex: null,
    showType: 'clients',
    showMessage: null,
    showComment: null,
    upsertClient: null,
    upsertExpert: null,
    upsertFacility: null,
    loginRole: getRole(),
    searchText: {
      expert: '',
      client: ''
    },
    searchedColumn: {
      expert: '',
      client: ''
    },
    filteredInfo: null
  }

  getColumnSearchProps = (dataIndex, type) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex, type)
          }
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex, type)
          }
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters, type)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const values = value.split(',')
      let filterValue = record[dataIndex]
      if (dataIndex === 'location') {
        filterValue =
          record.profile && record.profile.city ? record.profile.city : ''
      } else if (dataIndex === 'name') {
        filterValue = `${record.profile.nickname || record.first_name} ${
          record.last_name
        }`
      }
      return values.find((_value) =>
        filterValue
          .toString()
          .toLowerCase()
          .includes(_value.toLowerCase().trim())
      )
    },
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select())
      }
    },
    render: (text) =>
      this.state.searchedColumn[type] === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={this.getSearchWords(type)}
          autoEscape
          textToHighlight={text.toString()}
        />
      ) : (
        text
      )
  })

  getSearchWords = (type) =>
    this.state.searchText[type]
      ? this.state.searchText[type].split(',').map((item) => item.trim())
      : []

  aColumns = (facilities) => [
    {
      key: 'avatar',
      render: (text, record) => (
        <PolygonAvatar
          width={46}
          image={record.avatar && record.avatar.oss_url}
          innerId={`list-inner-${record.id}`}
          hexId={`list-hex-${record.id}`}
        />
      )
    },
    {
      title: 'NAME',
      key: 'name',
      dataIndex: 'name',
      ...this.getColumnSearchProps('name', 'client'),
      sorter: (a, b) => {
        const aName = `${a.profile.nickname || a.first_name} ${a.last_name}`
        const bName = `${b.profile.nickname || b.first_name} ${b.last_name}`

        return (
          aName.toLowerCase().charCodeAt() - bName.toLowerCase().charCodeAt()
        )
      },
      sortDirections: ['descend', 'ascend'],
      render: (text, record, index) => {
        const name = `${record.profile.nickname || record.first_name} ${
          record.last_name
        }`
        const isLocked = record.profile.pre_screening_locked
        return (
          <>
            {this.state.searchedColumn['client'] === 'name' ? (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={this.getSearchWords('client')}
                autoEscape
                textToHighlight={name.toString()}
              />
            ) : (
              name
            )}
            {isLocked && (
              <LockOutlined
                style={{
                  color: '#EA5400',
                  marginLeft: 5,
                  cursor: 'pointer',
                  fontSize: 24,
                  verticalAlign: 'top'
                }}
                onClick={(e) => {
                  e.stopPropagation()
                  Modal.confirm({
                    icon: (
                      <ExclamationCircleOutlined style={{ color: '#EA5400' }} />
                    ),
                    width: 480,
                    title: `Allow ${name} to start the onboarding process`,
                    content: (
                      <div>
                        Please direct the client to{' '}
                        <a
                          href="https://app.apeiron.life/sign-in"
                          _blank="target"
                        >
                          https://app.apeiron.life/sign-in
                        </a>{' '}
                        to continue with the logistics form
                      </div>
                    ),
                    okText: 'Confirm',
                    onOk: async () => {
                      const result = await editClient(
                        {
                          profile: {
                            pre_screening_locked: false
                          }
                        },
                        record.id
                      )
                      this.submitSync(result.team.person, 'update')
                    }
                  })
                }}
              />
            )}
            <br />{' '}
            <span
              style={{
                color: '#4C6072',
                opacity: 0.6,
                fontSize: 10
              }}
            >
              {record.id}
            </span>
          </>
        )
      }
    },
    {
      title: 'MEDICAL',
      key: 'profile.medical_status',
      dataIndex: 'profile.medical_status',
      filterMultiple: false,
      filters: [
        { text: 'Recorded', value: '1' },
        { text: 'UnRecorded', value: '0' }
      ],
      onFilter: (value, record) => {
        return `${record.profile.medical_status}` === value
      },
      render: (text, record) => {
        const role = getRole()
        return (
          <div className="medical-status">
            <Checkbox
              checked={record.profile.medical_status}
              disabled={role === 'Service_Provider'}
              onClick={(e) => {
                e.stopPropagation()
              }}
              onChange={(e) => {
                this.editClientMedicalStatus(
                  record.id,
                  e.target.checked ? 1 : 0
                )
              }}
            />
          </div>
        )
      }
    },
    {
      title: 'AGE',
      key: 'age',
      dataIndex: 'age',
      filters: [
        { text: '>61', value: '60,' },
        { text: '51-60', value: '50,60' },
        { text: '41-50', value: '40,50' },
        { text: '31-40', value: '30,40' },
        { text: '21-30', value: '20,30' },
        { text: '<=20', value: ',20' }
      ],
      onFilter: (value, record) => {
        const age =
          record.profile && record.profile.date_of_birth
            ? moment().diff(record.profile.date_of_birth, 'years')
            : 0
        const valueArr = value.split(',').map((item) => Number(item))
        if (valueArr[0] && !valueArr[1]) {
          return age > valueArr[0]
        } else if (valueArr[0] && valueArr[1]) {
          return age > valueArr[0] && age <= valueArr[1]
        } else if (!valueArr[0] && valueArr[1]) {
          return age <= valueArr[1]
        }
        return age
      },
      filterMultiple: false,
      render: (text, record, index) =>
        record.profile && record.profile.date_of_birth
          ? moment().diff(record.profile.date_of_birth, 'years')
          : '--'
    },
    {
      title: 'GENDER',
      dataIndex: 'profile.gender',
      filters: [
        { text: 'Male', value: 'male' },
        { text: 'Female', value: 'female' }
      ],
      filterMultiple: false,
      onFilter: (value, record) => {
        const gender =
          record.profile && record.profile.gender ? record.profile.gender : null
        return gender === value
      },
      render: (text, record, index) => (
        <span style={{ textTransform: 'capitalize' }}>
          {record.profile && record.profile.gender
            ? record.profile.gender
            : '--'}
        </span>
      )
    },
    {
      title: 'FACILITY',
      dataIndex: 'facility_ids',
      render: (text, record, index) => {
        return facilities
          .filter((f) => (text || []).includes(f.id))
          .map((f) => f.name)
          .join(', ')
      },
      filters: facilities.map((facility) => {
        return {
          text: facility.name,
          value: facility.id
        }
      }),
      filterMultiple: false,
      onFilter: (value, record) => {
        return record.facility_ids.includes(value)
      }
    },
    {
      title: 'MEMBER SINCE',
      render: (text, record, index) => {
        const clientSince =
          record && record.profile && record.profile.client_since
        if (clientSince) {
          const clientSinceMoment = moment(clientSince.substr(0, 10))
          const diff = moment().diff(clientSinceMoment, 'months')
          return `${clientSinceMoment.format('MMM DD, YYYY')} (${diff +
            (diff > 1 ? ' months' : ' month')})`
        } else {
          return '---'
        }
      }
    },
    {
      title: 'CONNECTED DEVICES',
      dataIndex: 'profile.devices',
      key: 'devices',
      render: (text, record, index) => {
        const devices =
          (record.profile && record.profile.device_connection_status) || {}
        const devicesList = Object.keys(devices).filter((item) => devices[item])
        return devicesList.length > 0 ? (
          <div className="devices-list">
            {devicesList.map((item, index) => {
              let source
              switch (item) {
                case 'ouraring':
                  source = OuraLogo
                  break
                case 'garmin':
                  source = GarminLogo
                  break
                case 'polar':
                  source = PolarLogo
                  break
                case 'withings':
                  source = WithingsLogo
                  break
                default:
                  source = HealthkitLogo
                  break
              }
              return <img src={source} key={index} alt="device" />
            })}
          </div>
        ) : (
          '--'
        )
      }
      // record.profile && record.profile.devices ? record.profile.devices : '--'
    },
    {
      key: 'action',
      title: 'ACTIONS',
      render: (text, record, index) => {
        const disabled = record.role === roleLevel.InternalAdmin || (record.role === roleLevel.Expert && record.person_character === CharacterLevel.admin)
        const loginRole = this.state.loginRole
        const loginUser = loadUser()
        return (
          <div className="link-group">
            <span
              className={`${disabled ? 'disabled' : ''} as-link`}
              style={{ marginLeft: 15 }}
              onClick={(e) => {
                e.stopPropagation()
                if (disabled) return
                this.setState({
                  showComment: record,
                  editIndex: index
                })
              }}
            >
              <img src={ActionNoteIcon} alt="comment" />
            </span>
            <span
              className={`${disabled ? 'disabled' : ''} as-link`}
              style={{ marginLeft: 15 }}
              onClick={(e) => {
                e.stopPropagation()
                if (disabled) return
                this.setState({
                  showMessage: record,
                  editIndex: index
                })
              }}
            >
              {record.new_message ? (
                <img src={ClientUnreadMessageIcon} alt="unread message" />
              ) : (
                <img src={ClientMessageIcon} alt="message" />
              )}
            </span>

            {loginRole !== 'Service_Provider' && (
              <span
                className={`${
                  disabled && !loginUser.can_edit_expert ? 'disabled' : ''
                } as-link`}
                style={{ marginLeft: 15 }}
                onClick={(e) => {
                  e.stopPropagation()
                  if (disabled && !loginUser.can_edit_expert) return
                  this.setState({
                    upsertClient: record,
                    editIndex: index
                  })
                }}
              >
                <img src={ClientActionEditIcon} alt="edit" />
              </span>
            )}
          </div>
        )
      }
    }
  ]

  expertColumns = (facilities) => [
    {
      key: 'avatar',
      render: (text, record) => (
        <PolygonAvatar
          width={46}
          image={record.avatar && record.avatar.oss_url}
          innerId={`list-inner-${record.id}`}
          hexId={`list-hex-${record.id}`}
        />
      )
    },
    {
      title: 'NAME',
      key: 'name',
      dataIndex: 'name',
      ...this.getColumnSearchProps('name', 'expert'),
      sorter: (a, b) => {
        const aName = `${a.profile.nickname || a.first_name} ${a.last_name}`
        const bName = `${b.profile.nickname || b.first_name} ${b.last_name}`

        return (
          aName.toLowerCase().charCodeAt() - bName.toLowerCase().charCodeAt()
        )
      },
      sortDirections: ['descend', 'ascend'],
      render: (text, record, index) => {
        const name = `${record.profile.nickname || record.first_name} ${
          record.last_name
        }`
        return (
          <>
            {this.state.searchedColumn['expert'] === 'name' ? (
              <Highlighter
                highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
                searchWords={this.getSearchWords('expert')}
                autoEscape
                textToHighlight={name.toString()}
              />
            ) : (
              name
            )}
          </>
        )
      }
    },
    {
      title: 'FACILITY',
      dataIndex: 'facility_ids',
      render: (text, record, index) => {
        return facilities
          .filter((f) => (text || []).includes(f.id))
          .map((f) => f.name)
          .join(', ')
      },
      filters: facilities.map((facility) => {
        return {
          text: facility.name,
          value: facility.id
        }
      }),
      filterMultiple: false,
      onFilter: (value, record) => {
        return record.facility_ids.includes(value)
      }
    },
    {
      title: 'SERVICE',
      dataIndex: 'services',
      filterMultiple: false,
      filters: expertServices.map((i) => {
        return {
          text: i,
          value: i
        }
      }),
      onFilter: (value, record) => {
        return record.services.includes(value)
      },
      render: (text, record, index) => {
        return _.get(record, 'services', []).join(', ')
      }
    },
    {
      title: 'CONTACT',
      render: (text, record, index) => {
        return (
          <div>
            <div>{record.email}</div>
            {record.profile.phone_number && (
              <div>{record.profile.phone_number}</div>
            )}
          </div>
        )
      }
    },
    {
      key: 'action',
      title: 'ACTIONS',
      render: (text, record, index) => {
        return (
          <div className="link-group">
            <span
              className={'as-link'}
              style={{ marginLeft: 15 }}
              onClick={(e) => {
                e.stopPropagation()
                this.setState({
                  upsertExpert: record,
                  editIndex: index
                })
              }}
            >
              <img src={ClientActionEditIcon} alt="edit" />
            </span>
          </div>
        )
      }
    }
  ]

  facilityColumns = () =>
    [
      {
        title: 'FACILITY',
        dataIndex: 'name',
        sorter: (a, b) =>
          a.name.toLowerCase().charCodeAt(0) -
          b.name.toLowerCase().charCodeAt(0)
      },
      {
        title: 'LOCATION',
        dataIndex: 'address',
        sorter: (a, b) =>
          a.address.toLowerCase().charCodeAt(0) -
          b.address.toLowerCase().charCodeAt(0)
      },
      {
        title: 'PHONE NUMBER',
        dataIndex: 'phone_number',
        sorter: (a, b) => {
          const extractNumbers = (phone) =>
            phone ? phone.replace(/\D/g, '') : ''

          const numA = extractNumbers(a.phone_number || '')
          const numB = extractNumbers(b.phone_number || '')

          return numA.localeCompare(numB, undefined, { numeric: true })
        }
      },
      {
        title: 'ACTIOINS',
        dataIndex: 'name',
        width: 42,
        render: (text, record, index) => {
          return (
            <div className="link-group">
              <ActionAuth
                permission={[PagePermissions.FACILITY, AuthOp.UPDATE]}
              >
                <span
                  className={'as-link'}
                  style={{ marginLeft: 15 }}
                  onClick={(e) => {
                    e.stopPropagation()
                    this.setState({
                      upsertFacility: record,
                      editIndex: index
                    })
                  }}
                >
                  <img src={ClientActionEditIcon} alt="edit" />
                </span>
              </ActionAuth>
            </div>
          )
        },
        perm: [PagePermissions.FACILITY, AuthOp.UPDATE]
      }
    ].filter((c) => PermFilter(_.get(c, 'perm'), this.props.account))

  markRead = () => {
    const { upsertClient, editIndex, clients } = this.state
    upsertClient.new_message = false
    clients.splice(editIndex, 1, upsertClient)
  }

  handleSearch = (selectedKeys, confirm, dataIndex, type) => {
    this.setState({
      searchText: _.assign({ ...this.searchText }, { [type]: selectedKeys[0] }),
      searchedColumn: _.assign(
        { ...this.searchedColumn },
        { [type]: dataIndex }
      )
    })
    confirm()
  }

  handleReset = (clearFilters, type) => {
    clearFilters()
    this.setState({
      searchText: _.assign({ ...this.searchText }, { [type]: '' })
    })
  }

  handleDeleteClient = (record) => {
    const isExpert = record.person_character === CharacterLevel.expert
    const deleteClient = this.deleteClient
    confirm({
      title: `Do you want to delete ${isExpert ? 'expert' : 'client'}: ${record
        .profile.nickname || record.first_name} ${record.last_name}?`,
      icon: <></>,
      className: deleteClientStyle,
      width: '546px',
      content: (
        <>
          <p>Please be aware when this account is deleted:</p>
          <ul>
            <li>You can't access this account anymore</li>
            <li>This account will no longer be able to log in</li>
            <li>
              You will not be able to retrieve this account data or reactivate
              this account. This is a permanent action
            </li>
            {!isExpert && (
              <li>Programs (if any) of this account will be canceled</li>
            )}
          </ul>
        </>
      ),
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        return deleteClient(record.id)
      },
      onCancel() {}
    })
  }

  deleteClient = async (id, index) => {
    let {
      assessment,
      coreClient,
      nonCoreClient,
      partner,
      testClient,
      admin,
      archive,
      prospect,
      experts
    } = this.state
    try {
      await deletePeople(id)
      assessment = assessment.filter((item) => item.id !== id)
      testClient = testClient.filter((item) => item.id !== id)
      experts = experts.filter((item) => item.id !== id)
      prospect = prospect.filter((item) => item.id !== id)
      admin = admin.filter((item) => item.id !== id)
      archive = archive.filter((item) => item.id !== id)
      partner = partner.filter((item) => item.id !== id)
      coreClient = coreClient.filter((item) => item.id !== id)
      nonCoreClient = nonCoreClient.filter((item) => item.id !== id)
      this.setState({
        assessment,
        testClient,
        createClient: false,
        experts,
        coreClient,
        nonCoreClient,
        partner,
        admin,
        archive,
        prospect
      })
      message.success('The account has been deleted!')
    } catch (err) {
      console.error(err)
      message.warning(err.message)
    }
  }

  editClientMedicalStatus = async (id, status) => {
    try {
      const result = await editClient(
        {
          profile: {
            medical_status: status
          }
        },
        id
      )
      this.submitSync(result.team.person, 'update')
    } catch (err) {
      console.error(err)
      message.error(err.message)
    }
  }

  initial = async (showWelcomePersonId) => {
    const [result, facilities] = await Promise.all([
      getClients(),
      getFacilties()
    ])
    const user = loadUser()

    const loginRole = getRole(user.role)
    this.setState({
      assessment: result.clients,
      coreClient: result.clients.filter(
        (item) =>
          getRole(item.role) === 'User' &&
          item.profile &&
          item.profile.account_type === userType.Core
      ),
      nonCoreClient: result.clients.filter(
        (item) =>
          getRole(item.role) === 'User' &&
          item.profile &&
          item.profile.account_type === userType.Non_Core
      ),
      testClient: result.clients.filter(
        (item) =>
          getRole(item.role) === 'User' &&
          item.profile &&
          item.profile.account_type === userType.Test_User
      ),
      partner: result.clients.filter(
        (item) =>
          getRole(item.role) === 'User' &&
          item.profile &&
          item.profile.account_type === userType.Partners
      ),
      archive: result.clients.filter(
        (item) =>
          getRole(item.role) === 'User' &&
          item.profile &&
          item.profile.account_type === userType.Archive
      ),
      prospect: result.clients.filter(
        (item) =>
          getRole(item.role) === 'User' &&
          item.profile &&
          item.profile.account_type === userType.Prospect
      ),
      experts: result.clients.filter(
        (item) => item.person_character === CharacterLevel.expert
      ),
      facilities: facilities,
      admin: result.clients.filter((item) => item.role === roleLevel.InternalAdmin || (item.role === roleLevel.Expert && item.person_character === CharacterLevel.admin)),
      loading: false,
      loginRole: loginRole
    })
    if (showWelcomePersonId) {
      const client = result.clients.find(
        (e) => e.id === parseInt(showWelcomePersonId)
      )
      client &&
        this.setState({
          initClient: client,
          editWelcomeEmail: true
        })
    }
  }

  submitSync = (person, type) => {
    const {
      assessment,
      coreClient,
      nonCoreClient,
      testClient,
      partner,
      admin,
      archive,
      prospect
    } = this.state
    let { initClient } = this.state
    if (type === 'create') {
      assessment.push(person)
      this.props.history.push(`/send-membership-selection/${person.id}`)
      switch (person.profile.account_type) {
        case 0:
          coreClient.push(person)
          break
        case 1:
          nonCoreClient.push(person)
          break
        case 2:
          testClient.push(person)
          break
        case -1:
          prospect.push(person)
          break
        default:
          break
      }
    } else {
      const editIndex = assessment.findIndex((item) => item.id === person.id)

      assessment.splice(editIndex, 1, person)

      const typesLists = {
        coreClient,
        nonCoreClient,
        testClient,
        partner,
        admin,
        archive,
        prospect
      }

      const handleData = (targetList) => {
        let isTypeChanged = false
        for (const key in typesLists) {
          if (targetList !== key) {
            const editIndex = typesLists[key].findIndex(
              (item) => item.id === person.id
            )
            if (editIndex >= 0) {
              typesLists[targetList].push(person)
              typesLists[key].splice(editIndex, 1)
              isTypeChanged = true
              break
            }
          }
        }
        if (!isTypeChanged) {
          const editIndex = typesLists[targetList].findIndex(
            (item) => item.id === person.id
          )
          typesLists[targetList].splice(editIndex, 1, person)
        }
      }
      if (getRole(person.role) === 'Expert') {
        handleData('admin')
      } else {
        switch (person.profile.account_type) {
          case 0:
            handleData('coreClient')
            break
          case 1:
            handleData('nonCoreClient')
            break
          case 2:
            handleData('testClient')
            break
          case 3:
            handleData('partner')
            break
          // case 4:
          //   handleData('coreClient')
          // break
          // case 5:
          //   handleData('coreClient')
          // break
          case 6:
            handleData('archive')
            break
          case -1:
            handleData('prospect')
            break
          default:
            break
        }
      }

      if (initClient && initClient.id === person.id) {
        initClient = person
      }
    }
    this.setState({
      assessment,
      coreClient,
      nonCoreClient,
      testClient,
      partner,
      archive,
      prospect,
      initClient
    }) // createClient: false
  }

  expertSubmitSync = (expert, type) => {
    const { experts } = this.state
    if (type === 'update') {
      const editIndex = experts.findIndex((item) => item.id === expert.id)
      experts.splice(editIndex, 1, expert)
    } else {
      experts.push(expert)
      this.setState({ upsertExpert: null })
    }
    this.setState({
      experts
    })
  }

  facilitySubmitSync = (facility, type) => {
    const { facilities } = this.state
    if (type === 'update') {
      const editIndex = facilities.findIndex((item) => item.id === facility.id)
      facilities.splice(editIndex, 1, facility)
    } else {
      facilities.push(facility)
      this.setState({ upsertFacility: null })
    }
    this.setState({
      facilities
    })
  }

  onDeleteFacility = (facility) => {
    Modal.confirm({
      title: `Do you want to delete facility: ${facility.name}?`,
      icon: <></>,
      width: '546px',
      content: <></>,
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk: () => this.handleDeleteFacility(facility),
      onCancel: () => {}
    })
  }

  handleDeleteFacility = async (facility) => {
    try {
      await deleteFacility(facility.id)
      this.setState({ upsertFacility: null })
      this.setState((prevState) => {
        const updatedFacilities = _.remove(
          [...prevState.facilities],
          (d) => d.id !== facility.id
        )
        return { facilities: updatedFacilities }
      })
    } catch (err) {
      console.error(err)
      message.warning(err.message)
    }
  }

  componentDidMount() {
    const { setClientBreadcrumb, location } = this.props
    const queryParams = new URLSearchParams(location.search)
    const showWelcomePersonId = queryParams.get('show-welcom')
    setClientBreadcrumb([getClientList(true)])
    this.setState({ loading: true })
    this.initial(showWelcomePersonId)
  }

  render() {
    const {
      assessment,
      coreClient,
      nonCoreClient,
      partner,
      testClient,
      admin,
      archive,
      prospect,
      facilities,
      experts,
      loading,
      upsertClient,
      upsertExpert,
      upsertFacility,
      editWelcomeEmail,
      showMembership,
      showedExportModal,
      showMessage,
      showComment,
      loginRole,
      filteredInfo
    } = this.state
    const { history, account } = this.props
    let tabs = [
      {
        tab: `CLIENTS (${coreClient.length})`,
        key: 'clients',
        dataSource: coreClient,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `NON-CORE (${nonCoreClient.length})`,
        key: 'nonCoreClient',
        dataSource: nonCoreClient,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `PARTNERS (${partner.length})`,
        key: 'Partner',
        dataSource: partner,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `TEST USERS (${testClient.length})`,
        key: 'testClient',
        dataSource: testClient,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `ADMIN (${admin.length})`,
        key: 'admin',
        dataSource: admin,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `ARCHIVE (${archive.length})`,
        key: 'archive',
        dataSource: archive,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `PROSPECTS (${prospect.length})`,
        key: 'prospect',
        dataSource: prospect,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `ALL CLIENTS (${assessment.length})`,
        key: 'assessment',
        dataSource: assessment,
        columns: this.aColumns(facilities).map((col) => ({
          ...col,
          filteredValue: filteredInfo
            ? filteredInfo[col.dataIndex] || null
            : null
        })),
        onClickRow: (record) => {
          history.push(`/client/${record.id}/detail`)
        },
        extra: {
          onChange: (pagination, filters, sorter) => {
            this.setState({ filteredInfo: filters })
          }
        }
      },
      {
        tab: `EXPERTS (${experts.length})`,
        key: 'experts',
        dataSource: experts,
        columns: this.expertColumns(facilities),
        hideForRoles: [CharacterLevel.service_provider, CharacterLevel.expert]
      },
      {
        tab: `FACILITIES (${facilities.length})`,
        key: 'facilities',
        dataSource: facilities,
        columns: this.facilityColumns(),
        onClickRow: (record) => {
          history.push(`/facility/${record.id}`)
        }
      }
    ].filter(
      (tab) =>
        !_.get(tab, 'hideForRoles', []).includes(account.user.person_character)
    )
    return (
      <div className={clientStyle}>
        <div className='users-header'>
          <div className="users-home-title">Home</div>
          <div className="users-action-container">
            {!['experts', 'facilities'].includes(this.state.showType) && (
              <>
                {facilities.length > 0 && (
                  <FacilityRadioGroup
                    facilities={facilities}
                    selectedFacilityId={
                      filteredInfo ? filteredInfo['facility_ids'] : null
                    }
                    callback={(value) => {
                      this.setState({
                        filteredInfo: _.assign({ ...filteredInfo }, value)
                      })
                    }}
                  />
                )}
                <ActionAuth permission={[PagePermissions.CLIENT, AuthOp.CREATE]}>
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() =>
                      this.setState({
                        upsertClient: {}
                      })
                    }
                  >
                    {' '}
                    ADD CLIENT
                  </Button>
                </ActionAuth>
              </>
            )}
            {this.state.showType === 'experts' && (
              <ActionAuth permission={[PagePermissions.EXPERT, AuthOp.CREATE]}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() =>
                    this.setState({
                      upsertExpert: {}
                    })
                  }
                >
                  {' '}
                  CREATE A NEW EXPERT
                </Button>
              </ActionAuth>
            )}
            {this.state.showType === 'facilities' && (
              <ActionAuth permission={[PagePermissions.FACILITY, AuthOp.CREATE]}>
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={() =>
                    this.setState({
                      upsertFacility: {}
                    })
                  }
                >
                  {' '}
                  CREATE A NEW FACILITY
                </Button>
              </ActionAuth>
            )}
          </div>
        </div>
        <div className="list-section">
          <Tabs
            defaultActiveKey="coreClient"
            onChange={(showType) => this.setState({ showType })}
            items={tabs.map(({ tab, key, dataSource, columns, ...rest }) => {
              return {
                label: tab,
                key: key,
                children: (
                  <DataTable
                    {...rest}
                    columns={columns}
                    dataSource={dataSource}
                    loading={loading}
                    hidePagination={true}
                  />
                )
              }
            })}
          />
        </div>
        {upsertClient && (
          <ClientForm
            initValue={upsertClient}
            loginRole={loginRole}
            facilities={facilities}
            onCancel={() => this.setState({ upsertClient: null })}
            submitSync={this.submitSync}
            editEmail={() =>
              this.setState({
                upsertClient: null,
                editWelcomeEmail: _.cloneDeep(upsertClient)
              })
            }
            sendMemeberShip={() =>
              this.setState({ upsertClient: null, showMembership: true })
            }
            onDelete={() => this.handleDeleteClient(upsertClient)}
            lockFacility={
              ![CharacterLevel.super_admin, CharacterLevel.admin].includes(
                account.user.person_character
              )
            }
          />
        )}
        {this.state.createdClient && (
          <CreatedClientModal
            send={() => {
              this.setState({
                createdClient: null,
                editWelcomeEmail: _.cloneDeep(this.state.createdClient)
              })
            }}
            skip={() => {
              this.setState({
                createdClient: null
              })
            }}
          />
        )}
        {editWelcomeEmail && (
          <WelcomeEmail
            onCancel={() => this.setState({ editWelcomeEmail: null })}
            person={editWelcomeEmail}
            experts={admin}
          />
        )}
        {showMembership && (
          <WelcomeEmail
            onCancel={() => this.setState({ showMembership: false })}
            isMembership={true}
            experts={admin}
            person={upsertClient}
          />
        )}
        {showedExportModal && (
          <ExportClientsDataModal
            assessment={assessment}
            close={() => this.setState({ showedExportModal: false })}
          />
        )}
        {showMessage && (
          <RightDrawer
            title={
              <div>
                <span
                  style={{
                    color: '#E75F25',
                    background: '#FDEEE6',
                    borderRadius: '100%',
                    display: 'inline-block',
                    marginRight: 12,
                    width: 32,
                    height: 32,
                    textAlign: 'center',
                    lineHeight: '32px'
                  }}
                >
                  <ChartIcon />
                </span>
                {`${showMessage.profile.nickname || showMessage.first_name} ${
                  showMessage.last_name
                }'s `}
                <span style={{ color: '#E75F25' }}>Chat</span>
              </div>
            }
            closeModal={() => this.setState({ showMessage: null })}
            visible={true}
          >
            <Message
              clientId={showMessage.id}
              markRead={showMessage.new_message ? this.markRead : null}
              sender={loadUser()}
            />
          </RightDrawer>
        )}

        {showComment && (
          <RightDrawer
            title={`${showComment.profile.nickname || showComment.first_name} ${
              showComment.last_name
            }'s notes`}
            closeModal={() => this.setState({ showComment: null })}
            visible={true}
          >
            <Notes person={showComment} noFilter />
          </RightDrawer>
        )}

        {upsertExpert && (
          <ExpertFormModal
            onCancel={() => this.setState({ upsertExpert: null })}
            facilities={facilities}
            initValue={upsertExpert}
            submitSync={this.expertSubmitSync}
            onDelete={() => this.handleDeleteClient(upsertExpert)}
          />
        )}

        {upsertFacility && (
          <FacilityFormModal
            onCancel={() => this.setState({ upsertFacility: null })}
            initValue={upsertFacility}
            submitSync={this.facilitySubmitSync}
            onDelete={this.onDeleteFacility}
          />
        )}
      </div>
    )
  }
}

export default ClientList
